import React from "react";
import { premium } from "./data/premium";
// import VehicleCard from "./VehicleCard";
import VehicleFullCard from "./VehicleFullCard";

export default function Premium() {
  return (


<>
<div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Premium Cars
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>




  <div className="vehicle-page">
    <div className="vehicle-container">
      {premium.map((v) => (
        <VehicleFullCard key={v.id} v={v} />
      ))}
    </div>
  </div>
  
{/* 
    <section className="vehicle-page">
      <div className="container">

        <div className="vehicle-grid">
          {premium.map((vehicle) => (
            <VehicleCard key={vehicle.id} v={vehicle} />
          ))}
        </div>
      </div>
    </section> */}
</>
  );
}
